import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f8d1e6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "media" }
const _hoisted_2 = {
  key: 0,
  class: "img"
}
const _hoisted_3 = ["src"]

import { storeToRefs } from 'pinia';
import { useMedia } from '@/store';
import Player from '../modal/Player.vue';
import CloseBtn from '../base/CloseBtn.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Media',
  setup(__props) {

const { isEnlarged, thumbnail, youtube } = storeToRefs(useMedia());
const { closeMedia } = useMedia();

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(CloseBtn, { onClick: _unref(closeMedia) }, null, 8, ["onClick"]),
    (_unref(thumbnail))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(thumbnail),
            alt: "",
            draggable: "false"
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    (_unref(youtube))
      ? (_openBlock(), _createBlock(Player, { key: 1 }))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, _unref(isEnlarged) && (_unref(thumbnail) || _unref(youtube))]
  ])
}
}

})